import { CAPTIONS_FONT_FAMILY_MAP } from '../../CaptionsButtonControl/consts.ts';
import { interFontFamily } from '../../../../../../../../utilities/interFontFamily.js';
import { FontOptionLabel } from '../../CaptionsButtonControl/types.ts';

export const getFontFamilyForFontOptionLabel = (fontOptionLabel: FontOptionLabel): string =>
  CAPTIONS_FONT_FAMILY_MAP.get(fontOptionLabel) ?? interFontFamily;
